export default "__VITE_ASSET__efff29c9__"